import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

const HakkimdaModal = React.memo(() => {
  const { user } = useSelector((state) => state.user);
  
  const initialAbout = useMemo(() => user?.data?.about || "", [user?.data?.about]);
  const [about, setAbout] = useState(initialAbout);

  useEffect(() => {
    setAbout(initialAbout);
  }, [initialAbout]);

  const handleAboutChange = useCallback((e) => {
    setAbout(e.target.value);
  }, []);

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor="about" className="labelEdit">
        Hakkımda
      </label>
      <textarea
        className="custom-input h-auto min-h-[224px] p-4"
        placeholder="Şimdi bir açıklama ekleyin ve profesyonel hikayenizi paylaşın..."
        id="about"
        name="about"
        value={about}
        onChange={handleAboutChange}
      />
    </div>
  );
});

export default React.memo(HakkimdaModal);
